import { create } from 'zustand'
import { persist } from 'zustand/middleware'

// create a zustand store for users
export const useUsersStore = create(
  persist(
    (set) => ({
      users: [],
      isLoading: false,
      handleUsers: (users) => set(() => ({ users })),
      handleLoading: (isLoading) => set(() => ({ isLoading })),
    }),
    // con partialize le dice al local storage lo que quiero guardar especificamente.
    { name: 'users', partialize: (state) => ({ users: state.users }) }
  )
)
